module.exports = __webpack_public_path__ + "static/media/GothamRnd-Medium.035295ad.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./src/fonts/GothamRnd-Medium.eot
 ** module id = 1353
 ** module chunks = 0
 **/